import { PageHero } from "@/components/common/PageHero";
import { ProjectsGrid, ContactBand } from "@/components/home/Sections";
import { useSeo } from "@/hooks/useSeo";
import { IMAGES } from "@/data/site";

export default function Projects() {
  useSeo({
    title: "Projects | Industrial Infrastructure, PEB & Material Handling — AutoMex",
    description: "Explore AutoMex project capabilities across industrial infrastructure, PEB, turnkey projects, material handling, machinery and automation.",
    path: "/projects",
  });
  return (
    <>
      <PageHero
        overline="Projects"
        title="Capabilities in Action."
        subtitle="Representative project types across our infrastructure and technology capabilities. Detailed case studies will be published here."
        image={IMAGES.infra}
        crumb="Projects"
      />
      <ProjectsGrid withHeading={false} />
      <ContactBand />
    </>
  );
}
